<div id="{{appName}}-app" class="troubleshootingsteps-dialog-content">
    <div mat-dialog-title>
        <div class="d-flex">
            <div>
                <h3>{{troubleshootingSteps.title}}</h3>
            </div>
            <div class="float-right ml-auto">
                <span class="fa fa-close action-icons" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content>
        <span *ngIf="troubleshootingSteps.message" class="informationOrquestion">
            <div class="troubleshootingsteps-dialog information-text flow-content-text col-12">
                <span class="info-content" #informationtext [innerHTML]="troubleshootingSteps.message | safeHtml">
                </span>
            </div>
        </span>

    </div>
</div>